export class GroupApplicantsModel {
  public GroupOrderId: number;
  public InvitationIds: number[] = [];
}
